import { Box } from "@mui/material";
import { actionPalette } from "../theme";
import type { ActionType } from "../generated/core-types";

interface ActionChipProps {
  action: ActionType;
  size?: "sm" | "md";
}

export function ActionChip({ action, size = "md" }: ActionChipProps): JSX.Element {
  const tone = actionPalette[action];
  const isSm = size === "sm";
  return (
    <Box
      component="span"
      sx={{
        display: "inline-flex",
        alignItems: "center",
        backgroundColor: tone.bg,
        color: tone.fg,
        border: `1px solid ${tone.fg}33`,
        borderRadius: "999px",
        padding: isSm ? "2px 8px" : "3px 10px",
        fontFamily: '"Geist", system-ui, sans-serif',
        fontSize: isSm ? "0.65rem" : "0.7rem",
        fontWeight: 500,
        letterSpacing: "0.14em",
        textTransform: "uppercase",
        whiteSpace: "nowrap",
        lineHeight: 1.2,
      }}
    >
      {tone.label}
    </Box>
  );
}
